import { render } from "./UserChangePasswordOffcanvas.vue?vue&type=template&id=04336660&scoped=true"
import script from "./UserChangePasswordOffcanvas.vue?vue&type=script&lang=js"
export * from "./UserChangePasswordOffcanvas.vue?vue&type=script&lang=js"

import "./UserChangePasswordOffcanvas.vue?vue&type=style&index=0&id=04336660&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04336660"]])

export default __exports__